/**
 * GROWK-31477 — cart icon on every product card, mobile and desktop (Symmetry 8.3.2).
 * One variant -> straight to the cart; several -> a variant picker: a sheet sliding up from
 * the bottom edge on mobile, a centred dialog from 768px up.
 * Add to cart repeats the theme's own <product-form> contract (assets/main.js): same
 * endpoint, sections payload, events and after-add behaviour, so the drawer, the header
 * counter and the cart apps behave as on a product page.
 *
 * Theme asset: <script src="{{ 'gw-cart-collections.js' | asset_url }}" defer></script>
 * Plain JS — Shopify runs no Liquid in a .js asset, so no Liquid and no <style>/<script>
 * tags here. The CSS below is kept dense on purpose: it ships inside a JS string, and
 * minification never touches string contents.
 */
(function () {
  if (window.jyQuickAdd) return;
  window.jyQuickAdd = true;

  /* jy- prefix, not gw-, to stay clear of the Growave app's own gw- classes.
     z-index: sheet above the theme's cart drawer (8001) so a variant list opened from its
     cross-sell stays usable; message above the sheet. 768px — the theme's own quick buy
     breakpoint — is the single place the mobile/desktop split is defined.
     The dim layer is a ::before animating opacity, not background-color on the full-screen
     box: opacity composites, background-color repaints the whole viewport every frame. It
     shares its duration and easing with the panel so both move as one.
     Closed state is visibility, never display:none — a display:none box has no resolved
     transform, so the first frame after showing it can skip the transition and make the
     panel pop in. visibility keeps the closed transform resolved at all times, and its own
     0s transition is delayed by the slide duration so the sheet stays visible while it
     slides back down. */
  var CSS = [
    '.jy-qa{position:absolute;right:8px;bottom:8px;z-index:2;display:flex;align-items:center;justify-content:center;width:36px;height:36px;padding:0;border:1px solid rgb(var(--text-color,35 35 35) / .1);border-radius:50%;background:#fff;color:rgb(var(--btn-bg-color,35 35 35));box-shadow:0 1px 5px rgb(0 0 0 / .14)}',
    '.jy-qa svg{width:19px;height:19px}',
    '.jy-qa:active{transform:scale(.9)}',
    '.jy-qa[disabled]{opacity:.5}',
    '.jy-qa-sheet{position:fixed;inset:0;z-index:8010;display:flex;align-items:flex-end;visibility:hidden;transition:visibility 0s linear .26s}',
    '.jy-qa-sheet.is-open{visibility:visible;transition-delay:0s}',
    '.jy-qa-sheet::before{content:"";position:absolute;inset:0;background:rgb(var(--modal-overlay-color,0 0 0) / .5);opacity:0;transition:opacity .26s cubic-bezier(.2,.8,.3,1)}',
    '.jy-qa-sheet.is-open::before{opacity:1}',
    '.jy-qa-panel{position:relative;width:100%;max-height:84vh;overflow-y:auto;padding:16px 16px calc(16px + env(safe-area-inset-bottom));border-radius:14px 14px 0 0;background:rgb(var(--quickbuy-bg,var(--bg-color,255 255 255)));color:rgb(var(--text-color,35 35 35));transform:translateY(100%);transition:transform .26s cubic-bezier(.2,.8,.3,1);will-change:transform}',
    '.jy-qa-sheet.is-open .jy-qa-panel{transform:none}',
    '.jy-qa-head{display:flex;justify-content:space-between;gap:12px;margin-bottom:6px;font-size:14px;line-height:1.35}',
    '.jy-qa-x{flex:none;width:28px;height:28px;padding:0;border:0;background:none;color:inherit;font-size:18px}',
    '.jy-qa-v{display:flex;justify-content:space-between;gap:12px;width:100%;margin-top:8px;padding:12px 14px;border:1px solid rgb(var(--text-color,35 35 35) / .25);border-radius:8px;background:none;color:inherit;font:inherit;text-align:left}',
    '.jy-qa-v[disabled]{opacity:.45}',
    '.jy-qa-v[disabled] span:first-child{text-decoration:line-through}',
    '.jy-qa-msg{position:fixed;right:16px;bottom:20px;left:16px;z-index:8020;padding:12px;border-radius:8px;font-size:14px;text-align:center;background:rgb(var(--btn-bg-color,35 35 35));color:rgb(var(--btn-text-color,255 255 255))}',
    'body.jy-qa-open{position:fixed;right:0;left:0;width:100%;overflow:hidden}',
    'body.jy-qa-open gty-whatsapp-chat-button{display:none!important}',
    '@media (min-width:768px){.jy-qa{width:40px;height:40px;right:10px;bottom:10px;transition:background-color .15s ease,color .15s ease}.jy-qa:hover{background:rgb(var(--btn-bg-color,35 35 35));color:rgb(var(--btn-text-color,255 255 255))}.jy-qa-sheet{align-items:center;justify-content:center;padding:24px}.jy-qa-panel{max-width:420px;max-height:min(84vh,560px);border-radius:14px;transform:translateY(16px)}.jy-qa-msg{left:50%;right:auto;bottom:24px;width:max-content;max-width:420px;transform:translateX(-50%)}}',
    '@media (prefers-reduced-motion:reduce){.jy-qa-sheet::before,.jy-qa-panel{transition:none}}'
  ].join('');

  var BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">'
    + '<path d="M15.3 9.5V5.3a3.3 3.3 0 0 0-6.6 0v4.2"/><path d="M5.4 7.7h13.2l1.1 13.6H4.3z"/></svg>';
  var sheet, opener, scrollY = 0, cache = {}, timer;

  /* The theme only exposes the format with the ISO code; the grid prints prices without it. */
  function money(cents) {
    var f = (theme.settings.moneyWithCurrencyFormat || '${{amount}}').replace(/\s*\b[A-Z]{3}\b\s*/, '');
    return f.replace(/\{\{\s*\w+\s*\}\}/, (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+\.)/g, ','));
  }

  function msg(text) {
    var el = document.querySelector('.jy-qa-msg');
    if (!el) { el = document.createElement('div'); el.className = 'jy-qa-msg'; document.body.appendChild(el); }
    el.textContent = text;
    clearTimeout(timer);
    timer = setTimeout(function () { el.remove(); }, 3000);
  }

  function add(variantId, done) {
    var secs = ['page-header', 'cart-drawer'].map(function (s) { return document.querySelector(s); }).filter(Boolean);
    var data = new FormData();
    data.append('form_type', 'product');
    data.append('utf8', '✓');
    data.append('id', variantId);
    data.append('quantity', 1);
    data.append('sections_url', location.pathname);
    data.append('sections', secs.map(function (el) { return el.dataset.sectionId; }).join(','));

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    }).then(function (res) {
      return res.json().then(function (json) {
        /* Shopify's own wording ("… is already sold out."). At quantity 1 a refused add
           changes nothing, so there is no cart state to resync. */
        if (!res.ok || json.status) throw new Error(json.description || json.message);
        return json;
      });
    }).then(function (json) {
      if (json.sections && secs.length === Object.keys(json.sections).length) {
        secs.forEach(function (el) { el.updateFromCartChange(json.sections[el.dataset.sectionId]); });
      } else {
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      }
      close();
      var drawer = document.querySelector('.js-cart-drawer');
      if (drawer && drawer.open) drawer.open(opener); else msg('Added to cart');
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: json.variant_id } }));
    }).catch(function (error) {
      msg(error.message || 'Could not add to cart');
    }).then(done);
  }

  /* Rows are variants, not options: one tap = one whole variant, whatever the option count. */
  function open(product) {
    if (!sheet) {
      sheet = document.createElement('div');
      sheet.className = 'jy-qa-sheet';
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
      sheet.innerHTML = '<div class="jy-qa-panel"><div class="jy-qa-head"><span></span>'
        + '<button type="button" class="jy-qa-x" aria-label="Close">&times;</button></div></div>';
      sheet.addEventListener('click', function (evt) {
        if (evt.target === sheet || evt.target.closest('.jy-qa-x')) close();
      });
      document.addEventListener('keydown', function (evt) { if (evt.key === 'Escape') close(); });
      document.body.appendChild(sheet);
    }

    var panel = sheet.querySelector('.jy-qa-panel');
    panel.querySelector('.jy-qa-head span').textContent = product.title;
    panel.querySelectorAll('.jy-qa-v').forEach(function (el) { el.remove(); });

    product.variants.forEach(function (variant) {
      var row = document.createElement('button');
      var name = document.createElement('span');
      var price = document.createElement('span');
      row.type = 'button';
      row.className = 'jy-qa-v';
      row.disabled = !variant.available;
      name.textContent = variant.title;
      price.textContent = variant.available ? money(variant.price) : 'Sold out';
      row.append(name, price);
      row.addEventListener('click', function () {
        row.disabled = true;
        add(variant.id, function () { row.disabled = false; });
      });
      panel.appendChild(row);
    });

    scrollY = window.scrollY;
    /* Freezing the body hides the scrollbar; pad the gap so desktop does not jump sideways. */
    var gap = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.top = -scrollY + 'px';
    if (gap > 0) document.body.style.paddingRight = gap + 'px';
    document.body.classList.add('jy-qa-open');
    /*
     * Resolve the closed transform before flipping the class. A transition needs a starting
     * value that has actually been computed once, and on the very first open the panel was
     * created in this same task — without this read the panel pops in while the dim layer
     * fades, which is exactly the jump this replaced. Reading the animated property is what
     * forces the recalculation; requestAnimationFrame would too, but it never fires in a
     * throttled tab.
     */
    void getComputedStyle(panel).transform;
    sheet.classList.add('is-open');
    sheet.querySelector('.jy-qa-x').focus();
  }

  function close() {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    document.body.classList.remove('jy-qa-open');
    document.body.style.top = '';
    document.body.style.paddingRight = '';
    window.scrollTo(0, scrollY);
    if (opener && document.body.contains(opener)) opener.focus();
  }

  function render() {
    document.querySelectorAll('product-block:not([data-jy-qa])').forEach(function (block) {
      block.dataset.jyQa = '';
      if (block.querySelector('.price-label--sold-out')) return;

      var image = block.querySelector('.image-cont');
      var link = block.querySelector('a.product-link[href*="/products/"]');
      if (!image || !link) return;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'jy-qa';
      button.setAttribute('aria-label', 'Add to cart');
      button.dataset.url = link.getAttribute('href');
      button.dataset.handle = button.dataset.url.split('/products/')[1].split(/[?#]/)[0];
      button.innerHTML = BAG;
      image.appendChild(button);
    });
  }

  function init() {
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    render();
    /* Cards keep arriving after load: collection filters, pagination, product page
       recommendations, search suggestions, and the cart drawer rebuilding its cross-sell. */
    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(render, 150);
    }).observe(document.body, { childList: true, subtree: true });

    /* Capture phase, so the tap never reaches the theme's own card handlers. */
    document.addEventListener('click', function (evt) {
      var button = evt.target.closest && evt.target.closest('.jy-qa');
      if (!button) return;
      evt.preventDefault();
      evt.stopPropagation();

      button.disabled = true;
      opener = button;
      var handle = button.dataset.handle;
      cache[handle] = cache[handle] || fetch(Shopify.routes.root + 'products/' + handle + '.js')
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); });

      cache[handle].then(function (product) {
        if (!product.available) { button.disabled = false; msg('Sold out'); return; }
        if (product.variants.length > 1) { button.disabled = false; open(product); return; }
        add(product.variants[0].id, function () { button.disabled = false; });
      }, function () {
        /* No product data to quick add from — open the product page, like the theme's own
           quick buy toggle does on mobile. */
        delete cache[handle];
        location.href = button.dataset.url;
      });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();